<script>
import { defineComponent, ref, watch, h as createEl } from 'vue'
import { toDecimalBR, parseNumberBR } from '@/components/Ajuda/Montador/lib/numbers'

export default defineComponent({
  name: 'DecimalField',
  props: {
    modelValue: { type: Number, default: null },
    digits: { type: Number, default: 2 },
    placeholder: String,
    class: String,
    min: Number,
    max: Number
  },
  emits: ['update:modelValue', 'blur'],
  setup(props, { emit, attrs }) {
    const text = ref('')
    const editing = ref(false)

    // Mostra o valor externo, mas não atropela enquanto o usuário digita
    watch(() => props.modelValue, (n) => {
      if (editing.value) return
      text.value = (n == null || Number.isNaN(n)) ? '' : toDecimalBR(n, props.digits)
    }, { immediate: true })

    function finish() {
      editing.value = false
      if (!text.value) { emit('update:modelValue', null); return }
      const num = parseNumberBR(text.value)
      emit('update:modelValue', Number.isFinite(num) ? num : null)
      text.value = (Number.isFinite(num) ? toDecimalBR(num, props.digits) : '')
    }

    function onInput(e) {
      editing.value = true
      let s = String(e.target.value ?? '')
      s = s.replace(/\./g, ',')        // 1.2 -> 1,2
      s = s.replace(/[^0-9,-]/g, '')   // dígitos, vírgula e sinal
      const parts = s.split(',')
      if (parts.length > 2) s = parts.shift() + ',' + parts.join('')
      text.value = s

      // Emite número enquanto digita, sem reformatar o texto do usuário
      const num = parseNumberBR(s)
      emit('update:modelValue', Number.isFinite(num) ? num : null)
    }

    function onBlur() { finish(); emit('blur') }
    function onKeydown(e) { if (e.key === 'Enter') finish() }

    return () => createEl('input', {
      type: 'text',
      inputmode: 'decimal',
      value: text.value,
      placeholder: props.placeholder,
      class: (props).class || 'form-control',
      min: props.min,
      max: props.max,
      onInput,
      onBlur,
      onKeydown,
      ...(attrs || {}),
    })
  },
})
</script>
